/**
 * 供应商详情 - 绩效指标标签页
 */
import React from 'react';
import { Row, Col, Card, Statistic, Descriptions } from 'antd';
import { DollarOutlined, RiseOutlined, ClockCircleOutlined } from '@ant-design/icons';

interface Supplier {
    cooperation_years?: number;
    total_order_count?: number;
    monthly_purchase_frequency?: number;
    average_order_amount?: number;
    on_time_delivery_rate?: number;
    delay_delivery_count?: number;
    first_purchase_date?: string;
    last_purchase_date?: string;
}

interface Props {
    supplier: Supplier;
}

const PerformanceTab: React.FC<Props> = ({ supplier }) => {
    return (
        <div>
            <h3 style={{ marginBottom: 16 }}>合作指标</h3>
            <Row gutter={16} style={{ marginBottom: 24 }}>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="合作年数"
                            value={supplier.cooperation_years || 0}
                            precision={1}
                            suffix="年"
                            prefix={<ClockCircleOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="总订单数"
                            value={supplier.total_order_count || 0}
                            prefix={<DollarOutlined />}
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="月均采购频率"
                            value={supplier.monthly_purchase_frequency || 0}
                            precision={2}
                            suffix="次/月"
                        />
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <Statistic
                            title="平均订单金额"
                            value={supplier.average_order_amount || 0}
                            precision={2}
                            prefix="¥"
                        />
                    </Card>
                </Col>
            </Row>

            <h3 style={{ marginBottom: 16 }}>履约绩效</h3>
            <Row gutter={16}>
                <Col span={12}>
                    <Card>
                        <Statistic
                            title="准时交货率"
                            value={supplier.on_time_delivery_rate || 0}
                            precision={2}
                            suffix="%"
                            prefix={<RiseOutlined />}
                            valueStyle={{ color: (supplier.on_time_delivery_rate || 0) > 90 ? '#3f8600' : '#faad14' }}
                        />
                    </Card>
                </Col>
                <Col span={12}>
                    <Card>
                        <Statistic
                            title="延迟交付次数"
                            value={supplier.delay_delivery_count || 0}
                            valueStyle={{ color: '#cf1322' }}
                        />
                    </Card>
                </Col>
            </Row>

            <Descriptions column={2} bordered style={{ marginTop: 24 }}>
                <Descriptions.Item label="首次采购日期">{supplier.first_purchase_date || '-'}</Descriptions.Item>
                <Descriptions.Item label="最近采购日期">{supplier.last_purchase_date || '-'}</Descriptions.Item>
            </Descriptions>
        </div>
    );
};

export default PerformanceTab;
